import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.IDIOMATICA;
export const LEVEL_COUNT = 18;
export const SUCCESS_LEVEL = 0.7;
export const SHORT_ONBOARDING_TEXT = 'Let\'s see if you can restore the Idiomatica.';
export const INTRO_TEXT = 'Before I forget, if you get stuck, tap on me for help!';
export const LITERAL_RECOGNIZE_TEXT = 'If I meant it literally, it would look like this.';
export const FIGURATIVE_RECOGNIZE_TEXTS = ['When I say ', ', I mean it figuratively'];
export const LITERAL_TEXT = ['Yes, ', ' is an idiom so it doesn\'t literally look like this.'];

// for intermediate saving and content update tracking
export const CURRENT_SAVE_DATA_VERSION = 1;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  SET_NEXT_STAGE: 'SET_NEXT_STAGE',
  SET_PREVIOUS_STAGE: 'SET_PREVIOUS_STAGE',
  SET_STAGE: 'SET_STAGE',
  SET_ANSWER_OPTIONS: 'SET_ANSWER_OPTIONS',
  REMOVE_ANSWER_OPTION: 'REMOVE_ANSWER_OPTION',
  FADE_IN: 'FADE_IN',
  FADE_OUT: 'FADE_OUT',
  ANIMATE_HINT_IN: 'ANIMATE_HINT_IN',
  ANIMATE_HINT_OUT: 'ANIMATE_HINT_OUT',
  ANIMATE_ORB: 'ANIMATE_ORB',
  ANIMATE_ILLUSTRATION_IN: 'ANIMATE_ILLUSTRATION_IN',
  ANIMATE_ILLUSTRATION_OUT: 'ANIMATE_ILLUSTRATION_OUT',
  SET_ITEM_AS_CORRECT: 'SET_ITEM_AS_CORRECT',
  SET_NEXT_ONBOARDING_STAGE: 'SET_NEXT_ONBOARDING_STAGE',
  SET_ONBOARDING_STAGE: 'SET_ONBOARDING_STAGE',
  GET_NEXT_ONBOARDING_ITEM: 'GET_NEXT_ONBOARDING_ITEM',
  GET_PREVIOUS_ONBOARDING_ITEM: 'GET_PREVIOUS_ONBOARDING_ITEM',
  SET_ONBOARDING_FEEDBACK_MODE: 'SET_ONBOARDING_FEEDBACK_MODE',
  ROUND_END: 'ROUND_END',
  SHOW_PAYOFF: 'SHOW_PAYOFF',
  UPDATE_GAME_DATA: 'UPDATE_GAME_DATA',
  QUICK_ROUND: 'QUICK_ROUND',
  LOAD_INTERMEDIATE_SAVE: 'LOAD_INTERMEDIATE_SAVE',
  UPDATE_RECORDS: 'UPDATE_RECORDS',
};

export const STAGES = {
  QUESTION: 0,
  INTRO: 1,
  RESPONSE: 2,
  ANSWER_OPTIONS_1: 3,
  CORRECTIVE_TEXT_1: 4,
  ANSWER_OPTIONS_2: 5,
  CORRECTIVE_TEXT_2: 6,
  LITERAL_RECOGNIZE: 7,
  FIGURATIVE_RECOGNIZE: 8,
  PROMPT_RECOGNIZE: 9,
  ANSWER_OPTIONS_3: 10,
  LITERAL: 11,
  EXPLANATION: 12,
};

export const ONBOARDING_STAGES = {
  FADE_IN: 0,
  FADE_SCROLL_IN: 1,
  FADE_SCROLL_OUT_MID: 2,
  FADE_SCROLL_IN_MID: 3,
  FADE_SCROLL_OUT: 4,
  FADE_OUT: 5,
};

export const ONBOARDING_ITEM_TYPES = {
  GUARD: 'GUARD',
  ANSWER: 'ANSWER',
  RESPONSE: 'RESPONSE',
};

export const MAZE_TYPES = {
  AIR: 'AIR',
  EARTH: 'EARTH',
  FIRE: 'FIRE',
  WATER: 'WATER',
};

export const CONTENT_TYPES = {
  RECOGNIZE: 'Recognize',
  DEFINE: 'Define',
  APPLY: 'Apply',
  REVIEW: 'Review',
};

export const ORB_POSITIONS = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT',
};

export const COLOR_SCHEME = {
  AIR: {
    TEXT_HIGHLIGHT: '#bee5db',
    MAZE: [
      '#A2B6CB', '#7994B5', '#5C728C', '#242C37', '#718CAD',
      '#95AAC5', '#819BB8', '#46566B', '#43904F', '#9B979B',
      '#A4C259', '#658BAA', '#7B9DBF', '#91B3DB',
    ],
  },
  EARTH: {
    TEXT_HIGHLIGHT: '#d8e5be',
    MAZE: [
      '#C8B2A2', '#A07959', '#7B5C42', '#30241A', '#977151',
      '#B4957D', '#A58063', '#5E4632', '#998B41', '#CCAD96',
      '#998B41', '#7B5C42', '#977151', '#B4947D',
    ],
  },
  FIRE: {
    TEXT_HIGHLIGHT: '#e5bebe',
    MAZE: [
      '#C39195', '#AC6060', '#854748', '#341C1C', '#A25B59',
      '#BE8283', '#AF6A6A', '#653737', '#3C6463', '#7A6969',
      '#4FAD85', '#854848', '#A35858', '#AC6060',
    ],
  },
  WATER: {
    TEXT_HIGHLIGHT: '#b2d6ff',
    MAZE: [
      '#A5B8B5', '#819A92', '#60736D', '#262E2C', '#7B948D',
      '#9BAFAA', '#88A098', '#4B5A55', '#244544', '#9B979B',
      '#675C59', '#76968E', '#77918A', '#89ADA4',
    ],
  },
};

export const WORKFLOW = {
  QUEST: 'QUEST',
  PRACTICE: 'PRACTICE',
};
